import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import DataTable from "./DiscountsListTable";
import MainTitle from "../../common/MainTitle";
import MainButton from "../../common/MainButton";
import TableMainSearch from "../../common/MainSearch";
import MainBodyTabs from "../financeTabs";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";

const DiscountsList = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `students/discounts/types?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  const routeTabs = [
    {
      name: "درآمد ها",
      path: "/mis/revenues/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/revenueBudgets",
    },
    {
      name: "تخفیف ها",
      path: "/mis/discounts",
    },
  ];

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.Discounts} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            type="add"
            title={lbl.AddDiscount}
            handleClick={() => togglePopUp({ form: "discount-type" })}
          />
          <MainPrintLink path={"discounts"} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={routeTabs} {...props} />
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default DiscountsList;
